module.exports = __webpack_public_path__ + "img/block-teal.43e648ae.webp";